"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _HomeSvg = _interopRequireDefault(require("../../assets/HomeSvg"));

var _LogoutSvg = _interopRequireDefault(require("../../assets/LogoutSvg"));

var _AmbassadorDashboardSvg = _interopRequireDefault(require("../../assets/AmbassadorDashboardSvg"));

var _links = require("../links");

var _helpers = require("../helpers");

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItems = function MenuItems(_ref) {
  var items = _ref.items,
      closeMenu = _ref.closeMenu;
  return items.map(function (item, i) {
    var _item$id;

    return /*#__PURE__*/_react.default.createElement(_styled.ProductContainer, {
      href: item.url,
      key: i,
      onClick: closeMenu,
      id: (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : item.label
    }, /*#__PURE__*/_react.default.createElement(_styled.ImageContainer, {
      alignIconToTop: item.alignIconToTop
    }, item.img), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styled.ProductTitle, {
      $color: item.color
    }, item.label), item.sub && /*#__PURE__*/_react.default.createElement("div", null, item.sub)));
  });
};

var Menu = function Menu(_ref2) {
  var setIsOpen = _ref2.setIsOpen,
      mainSiteUrl = _ref2.mainSiteUrl,
      pageType = _ref2.pageType,
      logOutUser = _ref2.logOutUser,
      user = _ref2.user,
      isInitInProgress = _ref2.isInitInProgress,
      avatarElement = _ref2.avatarElement,
      enableRemoteDoctor = _ref2.enableRemoteDoctor;

  var closeMenu = function closeMenu() {
    return setIsOpen(false);
  };

  var links = (0, _links.getLinks)(mainSiteUrl, enableRemoteDoctor);
  var isRemoteHealth = pageType.isRemoteHealth,
      isNomadHealth = pageType.isNomadHealth,
      isNomadInsurance = pageType.isNomadInsurance,
      isRemoteDoctor = pageType.isRemoteDoctor;

  var logout = function logout() {
    logOutUser && logOutUser();
    closeMenu();
  };

  return /*#__PURE__*/_react.default.createElement(_styled.MenuContainer, null, /*#__PURE__*/_react.default.createElement("div", null, !(user !== null && user !== void 0 && user.isAuthenticated) && !isInitInProgress && /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outline",
    onClick: function onClick() {
      return (0, _helpers.navigateToLogin)(mainSiteUrl, isRemoteHealth, isNomadHealth, isNomadInsurance, isRemoteDoctor);
    }
  }, "Log in"), (user === null || user === void 0 ? void 0 : user.isAuthenticated) && !isInitInProgress && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, avatarElement, /*#__PURE__*/_react.default.createElement(_styled.GlobalProfileMenu, null, /*#__PURE__*/_react.default.createElement(_styled.PageLink, {
    href: "".concat(mainSiteUrl, "/profile"),
    onClick: closeMenu
  }, /*#__PURE__*/_react.default.createElement(_styled.Icon, {
    as: _HomeSvg.default
  }), " Go to profile"), (user === null || user === void 0 ? void 0 : user.isAmbassador) && /*#__PURE__*/_react.default.createElement(_styled.PageLink, {
    href: "".concat(mainSiteUrl, "/ambassador"),
    onClick: closeMenu
  }, /*#__PURE__*/_react.default.createElement(_styled.Icon, {
    as: _AmbassadorDashboardSvg.default
  }), " Ambassador dashboard")), /*#__PURE__*/_react.default.createElement(_styled.HorizontalRule, null)), /*#__PURE__*/_react.default.createElement(_styled.LinksContainer, null, /*#__PURE__*/_react.default.createElement(_styled.MenuLabel, null, "Products"), /*#__PURE__*/_react.default.createElement(MenuItems, {
    closeMenu: closeMenu,
    items: links.products
  }), /*#__PURE__*/_react.default.createElement(_styled.MenuLabel, null, "Tools"), /*#__PURE__*/_react.default.createElement(MenuItems, {
    closeMenu: closeMenu,
    items: links.tools
  }), /*#__PURE__*/_react.default.createElement(_styled.MenuLabel, null, "About us"), links.about.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_styled.PageLink, {
      key: item.url,
      href: item.url,
      onClick: closeMenu,
      target: item.openInNewTab ? "_blank" : ""
    }, item.label);
  }), (user === null || user === void 0 ? void 0 : user.isAuthenticated) && !isInitInProgress && /*#__PURE__*/_react.default.createElement(_styled.LogoutButton, {
    onClick: logout
  }, /*#__PURE__*/_react.default.createElement(_styled.Icon, {
    as: _LogoutSvg.default
  }), " Log out"))));
};

Menu.propTypes = {
  setIsOpen: _propTypes.default.func,
  mainSiteUrl: _propTypes.default.string,
  pageType: _propTypes.default.object,
  logOutUser: _propTypes.default.func,
  user: _propTypes.default.object,
  isInitInProgress: _propTypes.default.bool,
  avatarElement: _propTypes.default.node,
  enableRemoteDoctor: _propTypes.default.bool
};
var _default = Menu;
exports.default = _default;